export const CHECKOUT_URL =
  'https://atlante-visivo-di-protesi-dentale.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/9ANBqvGGGgD3zqxtPGPo6U/Diseno_sin_titulo-5.png'

export const PRODUCT_NAME = 'ATLANTE VISIVO DI PROTESI DENTALE™'
export const PRODUCT_CLAIM = 'IL SISTEMA VISIVO COMPLETO PER LA PROTESI DENTALE'
export const TOPIC_LINE =
  'Fondamenti • Pianificazione • Protesi Fissa • Impianti • Protesi Rimovibile • Casi Clinici'
export const CTA_LABEL = '🦷 SÌ! VOGLIO IL SISTEMA COMPLETO'
export const GUARANTEE_LINE =
  '🛡️ Garanzia soddisfatti o rimborsati di 7 giorni  🦷 SISTEMA COMPLETO 6-IN-1'
export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const previewImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/n5ZmUeNHNeDrZR7yzbaSrs/Captura_de_pantalla_2026-09-06_a_la(s)_10.21.22_p._m..png',
    alt: 'Pagina interna — Rapporto corona-radice: quattro situazioni a confronto',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kcQgjVk3C82F2c85M3codP/Captura_de_pantalla_2026-09-06_a_la(s)_10.21.01_p._m..png',
    alt: 'Pagina interna — Mappa delle superfici dentali con legenda',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5qB7bZJLUQHdbs2y6qZJSw/Captura_de_pantalla_2026-09-06_a_la(s)_10.20.13_p._m..png',
    alt: 'Pagina interna — Errori biomeccanici da riconoscere',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gEBSvh5qTiS9SKVo5Djqh8/Captura_de_pantalla_2026-09-06_a_la(s)_10.19.50_p._m..png',
    alt: 'Pagina interna — Protesi dento-supportata vs implanto-supportata',
  },
]

export const heroIntro = [
  'Smetti di perdere tempo cercando riferimenti, confrontando materiali e consultando risorse sparse per analizzare ogni nuovo caso protesico.',
  'Accedi ad anatomia protesica visuale, pianificazione, preparazioni, protesi fissa, implantoprotesi, protesi rimovibile, occlusione, complicanze e casi clinici — organizzati in un unico sistema professionale.',
]

export const problemQuestions = [
  'Quale preparazione devo consultare?',
  'Quali aspetti devo valutare nella pianificazione?',
  'Come confronto materiali e soluzioni restaurative?',
  'Quali elementi devo osservare in una riabilitazione implantoprotesica?',
  'Come riconosco visivamente una possibile criticità?',
]

export const searchBlockItems = [
  'Fondamenti visuali di protesi.',
  'Diagnosi e pianificazione.',
  'Preparazioni e protesi fissa.',
  'Protesi su impianti.',
  'Protesi parziale e totale rimovibile.',
  'Occlusione, complicanze e casi clinici.',
  'Comparazioni visuali.',
  'Risorse professionali pronte da consultare.',
]

export const readyBlockItems = [
  'Hai bisogno di visualizzare una preparazione? È qui.',
  'Hai bisogno di confrontare diverse soluzioni protesiche? È qui.',
  'Hai bisogno di consultare rapidamente un workflow? È previsto.',
  'Implantoprotesi?',
  'Protesi rimovibile?',
  'Occlusione e complicanze?',
]

export const systemFeatures = [
  'Anatomia e biomeccanica visuale',
  'Diagnosi e pianificazione protesica',
  'Preparazioni e restauri indiretti',
  'Riabilitazioni implantoprotesiche',
  'Protesi rimovibile',
  'Occlusione e complicanze',
  'Risorse professionali pronte da consultare',
]

export const modules = [
  {
    num: 1,
    title: 'FONDAMENTI VISIVI DI PROTESI DENTALE™',
    body: 'Accedi a una base visuale e organizzata di anatomia dentale applicata, morfologia, occlusione, profili di emergenza, supporto, stabilità, ritenzione, biomeccanica e principali categorie di materiali protesici.',
    body2:
      'Utilizza schemi e riferimenti visuali strutturati per consultare rapidamente i principi fondamentali prima di approfondire una riabilitazione.',
    kicker: 'Osserva la struttura. Comprendi i principi. Consulta.',
  },
  {
    num: 2,
    title: 'DIAGNOSI E PIANIFICAZIONE PROTESICA™',
    body: 'Lavora con risorse visuali dedicate alla valutazione dentale, parodontale, occlusale ed estetica, allo spazio restaurativo, ai denti pilastro, al wax-up, al mock-up e alla selezione delle alternative protesiche.',
    kicker: 'Valuta i dati. Confronta le opzioni. Pianifica.',
  },
  {
    num: 3,
    title: 'PREPARAZIONI DENTALI E PROTESI FISSA™',
    body: 'Utilizza un sistema organizzato per consultare principi di preparazione, linee di finitura, riduzioni, corone, faccette, inlay, onlay, overlay, ponti, provvisori, impronte, scansioni e controlli finali.',
    body2:
      'Comparazioni visuali e strutture di riferimento permettono di riconoscere più facilmente caratteristiche corrette e possibili criticità.',
    kicker: 'Consulta. Confronta. Verifica.',
  },
  {
    num: 4,
    title: 'PROTESI SU IMPIANTI™',
    body: 'Accedi a componenti implantari, connessioni, abutment, Ti-base, profili di emergenza, restauri avvitati e cementati, ponti, workflow digitali e riabilitazioni implantoprotesiche.',
    body2:
      'Utilizza diagrammi, sezioni e comparazioni per comprendere visivamente la relazione tra impianto, componenti, tessuti e restauro.',
    kicker: 'Osserva. Collega. Analizza.',
  },
  {
    num: 5,
    title: 'PROTESI PARZIALE E TOTALE RIMOVIBILE™',
    body: 'Utilizza risorse organizzate su edentulia parziale e totale, supporto, stabilità, ritenzione, connettori, appoggi, ganci, selle, basi protesiche, rapporti intermascellari, occlusione e overdenture.',
    body2:
      'Passa direttamente dall’area da consultare a una struttura visuale chiara con componenti, principi e comparazioni.',
    kicker: 'Individua la struttura. Consulta. Valuta.',
  },
  {
    num: 6,
    title: 'OCCLUSIONE, COMPLICANZE E CASI CLINICI VISIVI™',
    body: 'Consulta occlusione, contatti statici e dinamici, interferenze, distribuzione dei carichi, usura, complicanze biologiche, meccaniche ed estetiche e casi protesici integrati.',
    body2:
      'Utilizza casi visuali, confronti, sequenze e checklist per collegare ciò che osservi ai fattori che richiedono verifica.',
    kicker: 'Osserva. Analizza. Collega.',
  },
]

export const bonuses = [
  {
    num: 1,
    title: 'PROSTHODONTIC CASE LIBRARY™',
    subtitle: 'Biblioteca Visiva di Casi Protesici',
    body: 'Accedi a casi protesici organizzati con scenario iniziale, elementi da osservare, alternative, workflow, controlli, complicanze e punti chiave.',
    body2:
      'Utilizza casi di protesi fissa, estetica, implantoprotesi, rimovibile e occlusione insieme al sistema principale.',
    kicker: 'Osserva. Confronta. Ragiona.',
  },
  {
    num: 2,
    title: 'PROSTHODONTIC ERRORS & SOLUTIONS ATLAS™',
    subtitle: 'Atlante Visivo di Errori, Complicanze e Soluzioni Protesiche',
    body: 'Organizza l’analisi di preparazioni, margini, contatti, occlusione, fratture, ritenzione, estetica, tessuti, componenti implantari e workflow digitali.',
    body2:
      'Utilizza matrici, alberi di verifica e confronti visuali per distinguere ciò che osservi dai fattori che devono essere verificati.',
    kicker: 'Riconosci. Verifica. Comprendi.',
  },
  {
    num: 3,
    title: 'DENTAL MATERIALS & RESTORATION SELECTION GUIDE™',
    subtitle: 'Guida Visiva alla Selezione di Materiali e Restauri',
    body: 'Trasforma caratteristiche, indicazioni e limiti dei materiali in un riferimento organizzato per confrontare le alternative restaurative senza cercare continuamente informazioni sparse.',
    body2:
      'Utilizza matrici, comparazioni e strumenti decisionali per mettere in relazione materiale, substrato, spazio, estetica, carichi e design.',
    kicker: 'Confronta i fattori. Valuta le opzioni. Scegli.',
  },
  {
    num: 4,
    title: 'PROSTHODONTIC CLINICAL WORKFLOW TOOLKIT™',
    subtitle: 'Toolkit di Workflow, Checklist e Strumenti Protesici',
    body: 'Organizza il workflow protesico dalla raccolta dati al mantenimento con checklist, schede di pianificazione, modelli di comunicazione, controlli di prova e strumenti di revisione.',
    body2:
      'Costruisci progressivamente un sistema professionale di riferimento che puoi consultare, compilare e riutilizzare nei diversi workflow protesici.',
    kicker: 'Organizza. Controlla. Documenta. Riutilizza.',
  },
]

export const differentiators = [
  {
    emoji: '🦷',
    title: 'Risorse visuali pronte da consultare',
    body: 'Apri il sistema e accedi a riferimenti organizzati invece di cercare ogni volta tra fonti diverse.',
  },
  {
    emoji: '📋',
    title: 'Workflow pratici e strutturati',
    body: 'Consulta preparazioni, restauri, componenti, comparazioni e sequenze in un formato chiaro.',
  },
  {
    emoji: '🧩',
    title: '6 aree essenziali',
    body: 'Mantieni fondamenti, pianificazione, protesi fissa, impianti, rimovibile e casi clinici organizzati.',
  },
  {
    emoji: '🔄',
    title: 'Risorse riutilizzabili',
    body: 'Torna a schemi, casi, checklist e strumenti ogni volta che devi consultare un nuovo argomento.',
  },
  {
    emoji: '📂',
    title: 'Biblioteca professionale organizzata',
    body: 'Smetti di cercare tra note, screenshot, documenti e riferimenti sparsi.',
  },
  {
    emoji: '⏱️',
    title: 'Meno ricerca',
    body: 'Passa meno tempo a cercare e organizzare riferimenti professionali.',
  },
]

export const offerIncludes = [
  '6 moduli professionali',
  '4 bonus professionali',
  'Anatomia e biomeccanica visuale',
  'Preparazioni e protesi fissa',
  'Implantoprotesi',
  'Protesi rimovibile',
  'Casi e complicanze',
  'Strumenti di workflow professionale',
]

export const testimonials = [
  {
    text: 'Lavoro in laboratorio da diciotto anni e la parte che mi ha convinto è il Modulo 3. Prima tenevo screenshot di linee di finitura sparsi in tre cartelle diverse; ora apro l’atlante, confronto le riduzioni e mando al clinico un riferimento visuale chiaro. Sulle preparazioni discutibili risparmio almeno due telefonate a caso.',
    author: 'Alessandro Ferretti',
    role: 'Odontotecnico, 43 anni',
    location: 'Bologna, Italia',
  },
  {
    text: 'Mi occupo soprattutto di protesi fissa ed estetica. Le comparazioni del Bonus 3 sulla selezione dei materiali sono diventate lo strumento che uso davanti al paziente: metto a confronto le alternative, spiego spazio, carichi ed estetica e la conversazione dura la metà. Il Modulo 2 mi ha riordinato completamente la fase di pianificazione.',
    author: 'Chiara Mancini',
    role: 'Odontoiatra libera professionista, 37 anni',
    location: 'Milano, Italia',
  },
  {
    text: 'La protesi rimovibile era l’area in cui perdevo più tempo a recuperare riferimenti. Il Modulo 5 mette connettori, appoggi, ganci e selle in un’unica struttura visuale che consulto prima di ogni progettazione. In due mesi ho smesso di aprire i vecchi manuali fotocopiati.',
    author: 'Giuseppe Lo Cascio',
    role: 'Odontotecnico specializzato in rimovibile, 51 anni',
    location: 'Palermo, Italia',
  },
  {
    text: 'Il Modulo 4 sull’implantoprotesi è quello che uso ogni settimana: connessioni, Ti-base, profili di emergenza, avvitato contro cementato. Le sezioni visuali mi hanno aiutato soprattutto nella comunicazione con il laboratorio, perché finalmente parliamo guardando lo stesso schema.',
    author: 'Martina Greco',
    role: 'Odontoiatra, ambito implantoprotesico, 34 anni',
    location: 'Padova, Italia',
  },
  {
    text: 'Ho comprato il sistema pensando fosse l’ennesimo PDF e invece è una biblioteca ordinata. L’atlante degli errori del Bonus 2 e le checklist del Bonus 4 sono entrati subito nel mio flusso di lavoro quotidiano: verifico margini, contatti e occlusione seguendo una sequenza sempre uguale, senza dimenticare passaggi.',
    author: 'Riccardo Barbieri',
    role: 'Odontoiatra protesista, 46 anni',
    location: 'Firenze, Italia',
  },
]

export const faqs = [
  {
    q: 'È un prodotto fisico?',
    a: 'No. ATLANTE VISIVO DI PROTESI DENTALE™ è una risorsa professionale 100% digitale.',
  },
  {
    q: 'A chi è rivolto questo sistema?',
    a: 'Ai professionisti del settore odontoiatrico e protesico che cercano risorse organizzate, visuali e pronte da consultare come supporto professionale.',
  },
  {
    q: 'È una certificazione o un corso di formazione?',
    a: 'No. È una risorsa professionale di consultazione e riferimento, non una certificazione né un sostituto della formazione professionale richiesta.',
  },
  {
    q: 'È un altro ebook pieno di teoria?',
    a: 'No. Il sistema principale si concentra su risorse visuali, preparazioni, restauri, implantoprotesi, comparazioni, casi clinici e strumenti pronti da consultare.',
  },
  {
    q: 'Devo creare personalmente i riferimenti e gli strumenti?',
    a: 'No. Le risorse sono già create e organizzate. Selezioni e utilizzi gli elementi appropriati in base al caso, al contesto e al tuo giudizio professionale.',
  },
  {
    q: 'Quali aree sono incluse?',
    a: 'Fondamenti Visivi di Protesi Dentale, Diagnosi e Pianificazione Protesica, Preparazioni Dentali e Protesi Fissa, Protesi su Impianti, Protesi Parziale e Totale Rimovibile e Occlusione, Complicanze e Casi Clinici Visivi.',
  },
  {
    q: 'Posso utilizzare le risorse in situazioni professionali differenti?',
    a: 'Le risorse forniscono strutture generali che possono essere utilizzate come riferimento e adattate dal professionista secondo il contesto, i dati disponibili e il proprio giudizio professionale.',
  },
  {
    q: 'Le risorse sono pronte da consultare?',
    a: 'Sì. Il sistema comprende risorse visuali progettate per una consultazione pratica in formato digitale.',
  },
  {
    q: 'Sono inclusi strumenti di pianificazione e organizzazione?',
    a: 'Sì. I quattro bonus complementari comprendono una biblioteca di casi, un atlante di errori e complicanze, una guida alla selezione dei materiali e un toolkit di workflow e checklist.',
  },
  {
    q: 'Come riceverò il prodotto?',
    a: 'Riceverai l’accesso digitale immediatamente dopo l’acquisto. Il sistema è in italiano e non sostituisce formazione, abilitazione professionale, linee guida applicabili o giudizio clinico.',
  },
]

export const recentBuyers = [
  { name: 'Alessandro F.', location: 'Bologna, Italia' },
  { name: 'Chiara M.', location: 'Milano, Italia' },
  { name: 'Giuseppe L.', location: 'Palermo, Italia' },
  { name: 'Martina G.', location: 'Padova, Italia' },
  { name: 'Riccardo B.', location: 'Firenze, Italia' },
  { name: 'Federica R.', location: 'Roma, Italia' },
  { name: 'Luca V.', location: 'Torino, Italia' },
  { name: 'Antonella D.', location: 'Napoli, Italia' },
  { name: 'Stefano C.', location: 'Verona, Italia' },
  { name: 'Valentina P.', location: 'Genova, Italia' },
  { name: 'Matteo S.', location: 'Bari, Italia' },
  { name: 'Elisa T.', location: 'Cagliari, Italia' },
]
